import { ShoppingListIngredientDetail } from "@/clients/models/ShoppingListIngredientDetail";

export const groupIngredientsByAisle = (
  ingredients: ShoppingListIngredientDetail[],
): Map<string, ShoppingListIngredientDetail[]> => {
  const grouped = new Map<string, ShoppingListIngredientDetail[]>();

  ingredients.forEach((ingredient) => {
    if (grouped.has(ingredient.category)) {
      grouped.set(ingredient.category, [
        ...grouped.get(ingredient.category)!,
        ingredient,
      ]);
    } else {
      grouped.set(ingredient.category, [ingredient]);
    }
  });

  return grouped;
};

export const getAisleIcon = (aisle: string) => {
  if (aisle.includes("Meat") || aisle.includes("Fish")) {
    return "🥩";
  }
  if (aisle.includes("Dairy")) {
    return "🥛";
  }
  if (aisle.includes("Fruit") || aisle.includes("Veg")) {
    return "🍎";
  }
  if (aisle.includes("Bakery")) {
    return "🍞";
  }
  if (aisle.includes("Pantry")) {
    return "🍳";
  }
  if (
    aisle.includes("Bread") ||
    aisle.includes("Rice") ||
    aisle.includes("Pasta")
  ) {
    return "🍝";
  }
  if (aisle.includes("Chilled") || aisle.includes("Fresh")) {
    return "🥬";
  }
  return "📦";
};
